const mutations = {
  UPDATE_PARTNERS(state, payload) {
    state.partners = payload;
  }
};

export default mutations;
